import { useEffect, useMemo } from 'react';
import type { FC } from 'react';
import { followingDotCursor } from 'cursor-effects';

// Small wrapper that mounts a 3rd-party cursor effect and cleans it up.
export const CursorEffects: FC = () => {
  const hasFinePointer = useMemo(() => typeof window !== 'undefined' && window.matchMedia?.('(pointer: fine)').matches, []);
  const prefersReducedMotion = useMemo(() => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches, []);

  useEffect(() => {
    if (!hasFinePointer || prefersReducedMotion) return;

    // Choose a subtle, accessible effect by default
    // You can switch to another: ghostCursor() or fairyDustCursor({ colors: ['#8b5cf6'] })
    const effect = followingDotCursor({ color: '#8b5cf6b3' });
    

    return () => {
      try {
        effect?.destroy?.();
      } catch {
        // ignore
      }
    };
  }, [hasFinePointer, prefersReducedMotion]);

  return null;
};

export default CursorEffects;
